<template>
	<div>
		<card>
			<Row :gutter="16">
			    <Col span="24">
					<div class="global-tool-bar">
						<div class="left-bar">
							<span class="title">品种客户数量统计分析</span>
							<DatePicker type="daterange"
							    v-model="selectDates"
							    size="small"
							    transfer
							    placement="bottom-end"
							    placeholder="选择期初和期末时间"
							    style=" margin-left:4px;width: 200px"
							    @on-change="onDateChange"></DatePicker>
								
								<Select v-model="productMainCategoryUuid"
								    style="width:200px;margin-left:5px;"
								    size="small"
								    placeholder="选择大类">
								   <Option v-for="item in mainCategorySource"
								   		:key="item.mainCategoryUuid" :value="item.mainCategoryUuid">
								   		{{ item.mainCategoryName }}</Option>
								</Select>
								<Select v-model="productSubCategoryUuid"
								    style="width:200px;margin-left:5px;"
								    size="small"
								    placeholder="选择小类">
								   <Option v-for="item in subCategorySource" :key="item.subCategoryUuid"
								   	:value="item.subCategoryUuid">{{ item.subCategoryName }}</Option>
								</Select>
											
								<Button type="success"
								    size="small"
								    class="btns"
								    icon="ios-stats"
								    @click="beginStat()">统计</Button>
						</div>
					</div>
				</Col>	
			</Row>
			
			<Row :gutter="16">
				<Col span="24">		
					<Table ref="mainTable"
					    :columns="mainTable.columns"
					    size="small"
					    :data="mainTable.data"
					    :loading="mainTable.loading"
					    :height="mainTable.tableHeight"
					    stripe
					    border />
					<Modal v-model="customerProductQantityModal.show"
						:width="1000"
						footer-hide>
						<Spin v-if="customerProductQantityModal.innerSpin"
							size="large"
							fix></Spin>
						<div slot="header">
							<span style="font-weight:bold;font-size: 14px;">品种客户数量统计</span>
						</div>
						<CustomerStatBar ref="customerStatBar"
							style="height: 400px;width:100%;"
							:value="customerProductQantityModal.barData"
							:text="customerProductQantityModal.barTitle" />
					</Modal>
				</Col>
			</Row>
		</card>
	</div>
	
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getCustomerCountAnalyze } from '@/api/modules/stat-analyze/customer-analyze';
import CustomerStatBar from '@/components/charts/customer-stat-bar.vue';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';	
import { pageInit4ProductEdit } from '@/api/modules/product-management/product-management';

export default{
    components:{
        StandPaginationTable,
        CustomerStatBar
    },
    data(){
        return{
            pageInitData: {},
            selectDates:[],
            mainCategorySource: [],
            subCategorySource: [],
            productMainCategoryUuid:'',
            productSubCategoryUuid:'',
            mainTable: {
				    columns: [],
				    data: [],
				    loading: false,
				    tableHeight: 100
            },
            customerProductQantityModal:{
                show: false,
                innerSpin: false,
                barTitle: '',
                barData: {}
            }
        };
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.getMainCategorySource();
        this.mainTable.tableHeight
				    = window.innerHeight
				    - this.$refs.mainTable.$el.offsetTop
				    - 210;
    },
    methods:{
        getTodayDateString,
        getThisMonthStart,
        queryStat(postData) {
			    this.mainTable.loading = true;
			    getCustomerCountAnalyze(postData).then(res => {
			        this.mainTable.loading = false;
			        if (res.code === 0) {
			            this.makeNewField();
			            this.mainTable.data = res.data.records;
			        }
			    });
        },
        getMainCategorySource() {
			    this.innerSpin = true;
			    let tempSearch = search.getSearchParams({ closeAllConditions: true });
			    pageInit4ProductEdit(tempSearch).then(res => {
			        this.innerSpin = false;
			        if (res.code === 0) {
                    this.pageInitData = res.data;
			            this.mainCategorySource = res.data.mainCategories.records;
			        }
			    });
        },
        onDateChange(e){
            this.selectDates = e;
        },
        onClickTab(e) {
            this.$nextTick(() => {
                this.beginStat();
            });
        },
        beginStat(){
            let postData = {
                beginDate: this.selectDates[0],
                endDate: this.selectDates[1],
                mainCategoryUuid:this.productMainCategoryUuid,
                subCategoryUuid: this.productSubCategoryUuid
            };
            this.queryStat(postData);
        },
        makeNewField(columns) {
			    this.mainTable.columns = [
                { title: '周次', key: 'week', width: 80, align: 'center', fixed: 'left' },
                { title: '客户数量', key: 'userCount', width: 60, align: 'center',
                    renderHeader: (h, { column, index }) => {
						    return h('div',
						        [
						            h('span', {}, column.title),
						            h('icon', {
						                props: {
						                    type: 'md-stats',
						                    size: 18,
						                    color: 'red'
						                },
						                style: {
						                    marginLeft: '8px'
						                },
						                on: {
						                    click: () => {
						                        this.showChart(column);
						                    }
						                }
						
						            })
						        ]
						    );
                    } 
                }
            ];
        },
        showChart(column) {
			
			    this.customerProductQantityModal.show = true;
			    this.customerProductQantityModal.innerSpin = true;
			    let barData = {};
			    for (let i = 0; i < this.mainTable.data.length - 1; i++) {
			        const e = this.mainTable.data[i];
			        barData[e['week']] = e[column.key];
			    }
			    this.customerProductQantityModal.barTitle = column.title;
			    this.customerProductQantityModal.barData = barData;
			    this.customerProductQantityModal.innerSpin = false;
			    this.$refs.customerStatBar.init();
        }
    },
    watch: {
		    'productMainCategoryUuid': {
		        immediate: true,
		        handler: function (newVal, oldVal) {
		            this.subCategorySource = [];
		            if (newVal !== '') {
		                this.subCategorySource = this.pageInitData.subCategories.records.filter(item => item.subCategoryMainUuid === newVal);
		            }
		
		            if (this.productSubCategoryUuid !== '') {
		                const find = this.subCategorySource.find(item => item.subCategoryUuid === this.productSubCategoryUuid);
		                if (!find) {
		                    this.productSubCategoryUuid = '';
		                }
		            }
		        }
		    }
    }
};
</script>

<style>
</style>